import * as types from 'store/mutation-types'
import storage from 'utils/storage'

const userKey = storage.get(process.env.LS_KEY_USER_DATA)
const version = 2
const keyPrefix = `${userKey}.kchart.studies`
const key = `${keyPrefix}.${version}`

let index = version - 1
while (index > 0) {
  storage.remove(`${keyPrefix}.${index}`)
  --index
}

export default function(store) {
  const data = storage.get(key)
  if (data) {
    setTimeout(() => {
      store.commit(types.INIT_STUDY, JSON.parse(data))
    }, 0)
  }

  store.subscribe((mutation, state) => {
    if ([types.SET_STUDY, types.UPDATE_STUDY].includes(mutation.type)) {
      storage.set(key, state.kchart.studies)
    }
  })
}
